import AccountMarketingMaterialShareQR from './AccountMarketingMaterialShareQR';

export default AccountMarketingMaterialShareQR;
